<template>
  <layout-main-inner
    title="商品交易统计"
    class="stat-inventory">
    <div slot="action">
      <el-date-picker
        v-model="query.month"
        style="width: 140px"
        type="month"
        placeholder="选择月"
        format="yyyy 年 MM 月"
        :clearable="false"
        :editable="false"
        @change="fetch">
      </el-date-picker>
      <el-button
        style="margin-left: 10px"
        type="primary"
        @click="fetch">查询</el-button>
    </div>
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">本期数据</template>
      <el-row>
        <el-col :span="24">
          <summary-list
            :span="6"
            :list="summaryList" />
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="14">
          <v-title title="本期商品销售情况（前20名）" />
          <product-chart :series="stock" />
        </el-col>
        <el-col :span="10">
          <v-title title="本期商品销售情况（20名以后）" />
          <product-table :list="stock.list" />
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="12">
          <v-title title="本期商品销售金额占比" />
          <product-precent-chart
            :legendData="pie1.legendData"
            :seriesData="pie1.seriesData"
            :selected="pie1.selected" />
        </el-col>
        <el-col :span="12">
          <v-title title="本期商品销售数量占比" />
          <product-precent-chart
            :legendData="pie2.legendData"
            :seriesData="pie2.seriesData"
            :selected="pie2.selected" />
        </el-col>
      </el-row>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import SummaryList from './busi/summary.vue'

import VTitle from './v-title.vue'
import ProductChart from './product/product-chart.vue'
import ProductTable from './product/product-table.vue'
import ProductPrecentChart from './product/product-precent-chart.vue'
const SLICE_NUM = 20
const SELECTED = 10
export default {
  name: 'StatProductNew',
  components: { SummaryList, ProductChart, ProductTable, ProductPrecentChart, VTitle },
  data() {
    return {
      loading: false,
      query: {
        month: +moment()
      },
      summaryList: [
        {
          label: '平均货单价',
          value: 0
        },
        {
          label: '销售金额',
          value: 0
        },
        {
          label: '商品种类',
          value: 0
        },
        {
          label: '商品总数',
          value: 0
        }
      ],
      stock: {
        xAxis: [],
        s1: [],
        s2: [],
        s3: [],
        list: []
      },
      pie1: {
        legendData: [],
        seriesData: [],
        selected: {}
      },
      pie2: {
        legendData: [],
        seriesData: [],
        selected: {}
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true
      const { month } = this.query
      this.$store.dispatch('stat/sumproducttrading', {
        payload: {
          beginDate: moment(month).startOf('month').format('YYYYMMDD'),
          endDate: moment(month).endOf('month').format('YYYYMMDD')
        },
        success: (res) => {
          this.loading = false
          console.log(res)
          this.$set(this, 'summaryList', [
            {
              label: '平均货单价',
              value: res.data.averageProductAmount
            },
            {
              label: '销售金额',
              value: res.data.totalAmount
            },
            {
              label: '商品种类',
              value: res.data.totalOrderedProductCount
            },
            {
              label: '商品总数',
              value: res.data.totalProductSoldQuantity
            }
          ])
          this.formatData(res.data.productTradings)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    formatData(detail) {
      const stockAllList = []
      detail.forEach(i => {
        const { productName, averageProductAmount, totalAmount, totalProductSoldQuantity, amountPercent, quantityPercent } = i
        stockAllList.push({
          productName, averageProductAmount, totalAmount, totalProductSoldQuantity, amountPercent, quantityPercent
        })
      })
      const stockList = _.sortBy(stockAllList, (i) => -i.totalAmount)
      const chartList = stockList.slice(0, SLICE_NUM)
      this.stock.xAxis = chartList.map(i => i.productName)
      this.stock.s1 = chartList.map(i => i.averageProductAmount)
      this.stock.s2 = chartList.map(i => i.totalAmount)
      this.stock.s3 = chartList.map(i => i.totalProductSoldQuantity)
      this.stock.list = stockList.slice(SLICE_NUM)

      const pie1Data = _.sortBy(stockAllList, (i) => -i.amountPercent)
      const pie1Result = this.formatPie(pie1Data, 'amountPercent')
      this.pie1.legendData = pie1Result.legendData
      this.pie1.seriesData = pie1Result.seriesData
      this.pie1.selected = pie1Result.selected

      const pie2Data = _.sortBy(stockAllList, (i) => -i.quantityPercent)
      const pie2Result = this.formatPie(pie2Data, 'quantityPercent')
      this.pie2.legendData = pie2Result.legendData
      this.pie2.seriesData = pie2Result.seriesData
      this.pie2.selected = pie2Result.selected
    },
    formatPie(list, key) {
      const legendData = []
      const seriesData = []
      const selected = {}
      list.forEach((i, idx) => {
        legendData.push(i.productName)
        seriesData.push({
          name: i.productName,
          value: i[key]
        })
        selected[i.productName] = idx < SELECTED
      })
      return {
        legendData,
        seriesData,
        selected
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
    .grid-content {
        height 300px;
    }
</style>
